import { AxiosResponse } from "axios";
import { apiClient } from "../../apiHelper";
import { useCreate } from "../react-query";

export function useUpdatePixelSpacing(
  onSuccess?: (response: AxiosResponse, data: any) => void,
  onError?: (response: AxiosResponse, error: Error) => void,
  notification: boolean = true
) {
  const updatePixelSpacing = async (formData: any) => {
    const response = await apiClient.post('/update_pixel_spacing', formData);
    return response;
  };

  return useCreate(
    updatePixelSpacing,
    ['update_pixel_spacing'],
    'Failed to update pixel spacing',
    'Pixel spacing updated successfully',
    onSuccess,
    onError,
    notification
  );
}
export function useSaveViews(
  onSuccess?: (response: AxiosResponse, data: any) => void,
  onError?: (response: AxiosResponse, error: Error) => void,
  notification: boolean = true
) {
  const saveViews = async (formData: any) => {
    const response = await apiClient.post('/create-realtime-dicom', formData);
    console.log('saveViews response', response);
    return response;
  };

  return useCreate(
    saveViews,
    ['create-realtime-dicom'],
    'Failed to save views',
    'Views saved successfully',
    onSuccess,
    onError,
    notification
  );
}